import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#797979",
      d: "M16.457 8.738v.494c-.006.048-.018.095-.019.142q-.016.505-.115 1c-.337 1.722-1.167 3.162-2.503 4.3a7.3 7.3 0 0 1-4.137 1.743c-.143.014-.289-.002-.429.039H8.76c-.047-.007-.094-.018-.142-.02a6.5 6.5 0 0 1-1.08-.13c-1.568-.32-2.906-1.061-3.994-2.233-1.153-1.24-1.808-2.71-1.968-4.4a7.3 7.3 0 0 1 .159-2.358c.355-1.514 1.1-2.81 2.264-3.841 1.83-1.624 3.972-2.225 6.377-1.798 1.729.306 3.164 1.163 4.301 2.499a7.3 7.3 0 0 1 1.74 4.126c.014.146 0 .294.04.438M9 15.432c3.535 0 6.418-2.871 6.438-6.38.021-3.583-2.872-6.473-6.396-6.495C5.468 2.535 2.58 5.43 2.558 8.954c-.021 3.58 2.889 6.49 6.441 6.478"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#797979",
      d: "M8.493 7.442q-.001-.772.001-1.543a.49.49 0 0 1 .356-.474.505.505 0 0 1 .563.195.46.46 0 0 1 .087.27q.002 1.563-.001 3.126a.49.49 0 0 1-.508.484.49.49 0 0 1-.496-.485c-.004-.524-.001-1.049-.001-1.573m1.272 4.65a.75.75 0 0 1-.773.76.76.76 0 0 1-.762-.765.77.77 0 0 1 .773-.77.76.76 0 0 1 .762.775"
    }, null, -1)
  ])))
}
export default { render: render }